import { render, staticRenderFns } from "./VisitorPositionInput.vue?vue&type=template&id=328c2dc0&"
import script from "./VisitorPositionInput.vue?vue&type=script&lang=js&"
export * from "./VisitorPositionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports